import React from 'react';
import { Outlet } from 'react-router-dom';
import MainBlock, { ColumnPosition } from '../shared/web/layout/MainBlock';
import SettingsMenu from './SettingsMenu';

export default function SettingsPagesWrapper(
  props: {
    hideSettingsMenu?: boolean,
    title: string
  }
) {
  const isHidden = props.hideSettingsMenu;

  return (
    <MainBlock
      title={props.title}
      columnPosition={ColumnPosition.LEFT}
      columnContent={!isHidden ? <SettingsMenu /> : undefined}
    >
      <Outlet />
    </MainBlock>
  );
}
